<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062839312_Contents#r_idParaDest-2"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Epigraph</span></span></a></h2>
<p class="pepi">To speak of knowledge is futile. All is experiment and adventure.</p>
<p class="pepi">We are forever mixing ourselves with unknown quantities.</p>
<div class="top">
<p class="peps"><span class="smallcaps">VIRGINIA WOOLF,</span> <span class="smallcaps_italic">THE WAVES</span><span class="smallcaps"></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062839312_Epigraph.vue?c12542f0